import { InsuranceCarrierEnum } from "./insurance";

export const ACP_ELIGIBLE_INSURERS = [
  InsuranceCarrierEnum.CDPHP,
  InsuranceCarrierEnum.CDPHP_MEDICAID,
  InsuranceCarrierEnum.MVP, // not a real insurer, retained by request, against the developer's counsel
  InsuranceCarrierEnum.MVP_HEALTHCARE,
  InsuranceCarrierEnum.MVP_MEDICAID,
  InsuranceCarrierEnum.MVP_MEDICARE,
  InsuranceCarrierEnum.OTHER,
] as const;
